import useFormat from '@/views/utils'

import { getOrderRow } from '../utils/utils'

const { formatDate } = useFormat()

export default {
    getAllOrders: state => {
        if (state.all_orders) {
            return state.all_orders.map(el => getOrderRow(el))
        }
        return []
    },
    getTotalOrders: state => state.totalOrders,
    getTotalPrice: state => state.totalPrice,
    getTotalDiscount: state => {
        if (!state.totalPrice || state.totalPrice < 0) return 0
        if (!state.totalFinalPrice || state.totalFinalPrice < 0)
            return state.totalPrice
        return state.totalPrice - state.totalFinalPrice
    },
    getTotalFinalPrice: state => state.totalFinalPrice,
    getFrom: state => state.from,
    getTo: state => state.to,
    getCurrentPage: state => state.currentPage,
    getStatusesForFilter: state => {
        return state.statuses.map(e => ({
            value: e.id,
            text: e.name,
            color: e.color,
        }))
    },
    getRestaurants: state => state.restaurants,
    getRestaurantsForFilter: state => {
        return state.restaurants.map(e => ({
            value: e.id,
            text: e.name,
            brand: e.brand_id,
        }))
    },
    getOperatorsForFilter: state => {
        return state.operators.map(e => ({
            value: e.id,
            name: `${e.last_name} ${e.first_name ? e.first_name : ''} ${
                e.middle_name ? e.middle_name : ''
            }`,
        }))
    },
    getBrandIds: state => {
        return state.brands.map(brand => brand.id)
    },
    getBrandsForFilter: state => {
        return state.brands.map(e => ({
            value: e.id,
            name: e.name,
        }))
    },
    getCountFilters: state =>
        Object.values(state.paramsSearch).filter(e => {
            return Array.isArray(e) ? e.length > 0 : !!e
        }).length,
    getPeriodFromFilters: state =>
        !state.paramsSearch['order-date']
            ? ''
            : state.paramsSearch['order-date'].replace('to', '-'),

    // TODO isolate
    getLastNotification: state => {
        if (!state.notifications || state.notifications.length === 0)
            return null
        const tempNotifications = structuredClone(state.notifications)

        tempNotifications.sort((a, b) => {
            return new Date(b.send_date) - new Date(a.send_date)
        })

        if (!tempNotifications[0] || !tempNotifications[0]?.send_date)
            return null

        return {
            label: `Последнее уведомление ${formatDate(
                tempNotifications[0].send_date
            )} (${tempNotifications[0].send_channel})`,
        }
    },
    getOrderBrand: state => {
        if (
            !state.brands ||
            !state.brands.length ||
            !state.view_order?.brand_id
        )
            return ''

        return state.brands.find(e => e.id === state.view_order.brand_id)
    },
    getCookeryIntervals: state => state.cookeryIntervals,

    getFinalPrice: state => {
        if (!state.view_order?.payments || !state.view_order?.payments.length)
            return 0
        return state.view_order.payments.reduce((sum, payment) => {
            return sum + payment.final_price
        }, 0)
    },
    getPrice: state => {
        if (!state.view_order?.payments || !state.view_order?.payments.length)
            return 0
        return state.view_order.payments.reduce((sum, payment) => {
            return sum + payment.price
        }, 0)
    },
    getErrorOrdersData: state => {
        return state.errorOrdersData
            ? state.errorOrdersData[0]
            : state.errorOrdersData
    },
}
